import React from 'react';

import Pagination from '../../../Pagination/Pagination';

const CustomPagination = ({ pagination }) => {
  if (pagination && pagination.component === undefined) {
    return <Pagination {...pagination} />;
  }
  if (pagination && pagination.component) {
    return <pagination.component {...pagination} />;
  }
  return null;
};

export default CustomPagination;
